import { Game } from 'model/Game'
import { User } from 'model/User'
import GameHistory from 'component/MyPage/GameHistory'
import { Button, Card, CardContent } from '@mui/material'
import { ArrowBackIosNew } from '@mui/icons-material'

type Props = {
  isSubscriber: boolean
  isOwnPage: boolean
  user: User
  games: Game[]
  backToTop: () => void
}
export default function GameHistoryList(props: Props) {
  return (
    <>
      <Button
        startIcon={<ArrowBackIosNew />}
        onClick={() => props.backToTop()}
      >
        戻る
      </Button>
      <Card variant='outlined'>
        <CardContent>
          <GameHistory
            isSubscriber={props.isSubscriber}
            isOwnPage={props.isOwnPage}
            user={props.user}
            games={props.games}
          />
        </CardContent>
      </Card>
    </>
  )
}